import { render, staticRenderFns } from "./BackgroundGallery.vue?vue&type=template&id=3d2e2418&scoped=true&"
import script from "./BackgroundGallery.vue?vue&type=script&lang=ts&"
export * from "./BackgroundGallery.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundGallery.vue?vue&type=style&index=0&id=3d2e2418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e2418",
  null
  
)

export default component.exports